import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 取消订单
export function cancelPoInfo(data) {
  return request({
    url: URL.order.cancelPoInfo,
    method: 'post',
    data
  })
}
// 删除订单
export function deletePoInfo(params) {
  return request({
    url: URL.order.deletePoInfo,
    method: 'post',
    params
  })
}
// 批量删除订单
export function batchDeletePoInfo(data) {
  return request({
    url: URL.order.batchDeletePoInfo,
    method: 'post',
    data
  })
}
// 批量导入订单相关信息
export function importPoInfo() {
  return request({
    url: URL.order.importPoInfo,
    method: 'post'
  })
}
// 批量导入包装相关信息
export function importPoPackage() {
  return request({
    url: URL.order.importPoPackage,
    method: 'post'
  })
}
// 载入一个订单
export function queryPoInfo(params) {
  return request({
    url: URL.order.queryPoInfo,
    method: 'post',
    params
  })
}
// 查询订单SKU列表
export function queryPoInfoItemPageable(data) {
  return request({
    url: URL.order.queryPoInfoItemPageable,
    method: 'post',
    data
  })
}
// 查询订单列表
export function queryPoInfoPageable(data) {
  return request({
    url: URL.order.queryPoInfoPageable,
    method: 'post',
    data
  })
}
// 根据ItemNo载入item
export function queryPoItemByItemNo(data) {
  return request({
    url: URL.order.queryPoItemByItemNo,
    method: 'post',
    data
  })
}
// 查询订单包装列表
export function queryPoPackageItemPageable(data) {
  return request({
    url: URL.order.queryPoPackageItemPageable,
    method: 'post',
    data
  })
}
// 保存订单
export function savePoInfo(data) {
  return request({
    url: URL.order.savePoInfo,
    method: 'post',
    data
  })
}
// 拆单
export function splitPo(data) {
  return request({
    url: URL.order.splitPo,
    method: 'post',
    data
  })
}

// 保存订单商品
export function savePoInfoIten(data) {
  return request({
    url: URL.order.savePoInfoIten,
    method: 'post',
    data
  })
}

// 保存订单商品-验证是否可以编辑skuNo
export function checkSavePoInfoItem(data) {
  return request({
    url: URL.order.checkSavePoInfoItem,
    method: 'post',
    data
  })
}

// 保存订单包装
export function savePoPackage(data) {
  return request({
    url: URL.order.savePoPackage,
    method: 'post',
    data
  })
}

// 查询包装统计信息
export function queryPoPackageSumInfo(data) {
  return request({
    url: URL.order.queryPoPackageSumInfo,
    method: 'post',
    data
  })
}

// 删除订单商品
export function deletePoInfoItem(params) {
  return request({
    url: URL.order.deletePoInfoItem,
    method: 'post',
    params
  })
}

// 删除订单包装
export function deletePoPackage(params) {
  return request({
    url: URL.order.deletePoPackage,
    method: 'post',
    params
  })
}

// 批量删除订单包装
export function deletePoPackages(requestBody) {
  return request({
    url: URL.order.deletePoPackages,
    method: 'post',
    data: requestBody
  })
}

// 根据customerId查询订单
export function searchPoInfoByPoNo(data) {
  return request({
    url: URL.order.searchPoInfoByPoNo,
    method: 'post',
    data
  })
}

// 查询订单sku
export function searchPoItem(data) {
  return request({
    url: URL.order.searchPoItem,
    method: 'post',
    data
  })
}

// 查询订单sku
export function queryPoPackage(params) {
  return request({
    url: URL.order.queryPoPackage,
    method: 'post',
    params
  })
}

// 完成订单
export function finishPoInfo(params) {
  return request({
    url: URL.order.finishPoInfo,
    method: 'post',
    params
  })
}

// 查询订单sku
export function batchFinishPoInfo(params) {
  return request({
    url: URL.order.batchFinishPoInfo,
    method: 'post',
    params
  })
}

// 订单日报导出
export function exportPoInfoDailyReport(data) {
  return request({
    url: URL.order.exportPoInfoDailyReport,
    method: 'post',
    responseType: 'blob',
    data
  })
}
// 订单fcl日报导出
export function exportPoInfoFclReport(data) {
  return request({
    url: URL.order.exportPoInfoFclReport,
    method: 'post',
    responseType: 'blob',
    data
  })
}
// 订单po report导出
export function exportPoReport(data) {
  return request({
    url: URL.order.exportPoReport,
    method: 'post',
    responseType: 'blob',
    data
  })
}

// 订单日报导出
export function exportPoInfoPackageDetail(data) {
  return request({
    url: URL.order.exportPoInfoPackageDetail,
    method: 'post',
    responseType: 'blob',
    data
  })
}

// 根据公司和部门获取指定权限下面的用户
export function getUsersByOfficeAndDept(data) {
  return request({
    url: URL.order.getUsersByOfficeAndDept,
    method: 'post',
    responseType: 'blob',
    data
  })
}

// 根据公司和部门获取用户详情
export function getUsersByUserId(params) {
  return request({
    url: URL.order.getUsersByUserId,
    method: 'get',
    params
  })
}
// 恢复订单
export function batchRenewPoInfo(params) {
  return request({
    url: URL.order.batchRenewPoInfo,
    method: 'post',
    params
  })
}
